<template>
  <div class="top-row">
    <div class="time-round">
      <div class="timer">
        <img :src="require('@/assets/timer.svg')" id="timer-img" />
        <p id="timer-text">Time Left: {{ roomData.roundTime }}</p>
      </div>
    </div>
    <div class="time-round">
      <h2 class="timer-round">Round: {{ 4 - roomData.round }}</h2>
    </div>
    <div class="time-round">
      <h2 class="word" v-if="isMaster">
        {{ wordToGuess }}
      </h2>

      <h2 class="word" v-else>
        <b v-for="word in wordToGuess" id="half-word">_ </b>
      </h2>
    </div>
  </div>

  <div id="canvas"></div>
  <div>
    <!-- <li>
        <label for="color">Color:</label>
        <input v-model="color" type="color" id="color" />
      </li> -->
  </div>
  <div class="paletteHolder">
    <div class="palette-holder-holder">
      <Palette
        v-for="(paletteColor, index) in paletteColors"
        :key="index"
        :bgColor="paletteColor"
        @click="changeColor(paletteColor)"
        class="color"
      />
    </div>
    <br v-if="isMobile" />
    <input v-model="weight" type="number" min="2" max="200" id="stroke-input" />
    <button @click="clearBoard" id="clear">clear</button>
  </div>
</template>

<script>
import * as socketio from "../plugins/socketio";
import P5 from "p5";
import Palette from "./Palette.vue";

export default {
  components: { Palette },
  props: {
    room_prop: Object,
  },
  data() {
    return {
      roomData: "",
      paths: [],
      currentPath: [],
      color: 0,
      weight: 3,
      wordToGuess: "",
      isMaster: false,
      paletteColors: [
        "#FF0000",
        "#FFFFFF",
        "#00FFFF",
        "#C0C0C0",
        "#0000FF",
        "#808080",
        "#00008B",
        "#000000",
        "#ADD8E6",
        "#FFA500",
        "#800080",
        "#A52A2A",
        "#FFFF00",
        "#800000",
        "#00FF00",
        "#008000",
        "#FF00FF",
        "#808000",
        "#FFC0CB",
        "#7FFD4",
      ],
      isMobile: false,
    };
  },
  mounted() {
    const isSmallScreen = window.matchMedia("(max-width: 1200px)").matches;

    const isMobile = window.matchMedia("(max-width: 500px)").matches;

    this.isMobile = isMobile;

    socketio.addEventListener({
      type: "roomState",
      callback: (roomData) => {
        this.roomData = roomData;
        this.wordToGuess = roomData.guessWord;
        this.isMaster =
          roomData.roomMaster.playerSocketId == socketio.clientSocketId();
      },
    });
    console.log("sketch 50", socketio.clientSocketId());
    console.log("Sketch Props", this.room_prop);

    const script = (p5) => {
      // let img;
      // p5.preload=()=>{
      //   img = p5.loadImage('logo.png')
      // }
      p5.setup = () => {
        p5.createCanvas(600, 400);

        if (isMobile) {
          document.getElementById("defaultCanvas0").style.width = "89vw";
          document.getElementById("canvas").style.width = "93vw";
          document.getElementById("canvas").style.height = "320px";
          document.getElementById("defaultCanvas0").style.height = "300px";
          document.getElementById("defaultCanvas0").style.overflow = "hidden";
          document.getElementById("defaultCanvas0").style.touchAction = "none";
        } else if (isSmallScreen) {
          document.getElementById("defaultCanvas0").style.width = "37vw";
          document.getElementById("canvas").style.width = "39vw";
        }

        p5.background(255);
        socketio.addEventListener({
          type: "mouse",
          callback: ({ paths }) => {
            // console.log(paths)
            paths.forEach((path) => {
              p5.beginShape();
              path.forEach((point) => {
                p5.strokeWeight(point.weight);
                p5.stroke(point.penColor);
                p5.vertex(point.x, point.y);
              });
              p5.endShape();
            });
          },
        });
        socketio.addEventListener({
          type: "ClearBoard",
          callback: () => {
            console.log("clearing boss");
            this.paths = [];
            p5.clear();
            p5.background(255);
          },
        });
      };

      // if (this.roomData !== null && this.roomData.roomMaster.playerSocketId === socketio.clientSocketId()) {
      console.log("am chosen one!");
      p5.draw = () => {
        if (this.roomData.choosingWord) {
          this.paths = [];
          p5.clear();
          p5.background(255);
          //clear with delay
          setTimeout(() => {
            p5.clear();
            p5.background(255);
          }, 150);
        }

        // p5.background(200)
        // p5.image(img, p5.mouseX, p5.mouseY, 50, 50)
        // p5.cursor(img, 32,32)
        p5.noFill();
        // p5.ellipse(p5.mouseX, p5.mouseY, this.weight, this.weight)
        if (
          p5.mouseIsPressed &&
          this.roomData.roomMaster.playerSocketId === socketio.clientSocketId()
        ) {
          const point = {
            x: p5.mouseX,
            y: p5.mouseY,
            penColor: this.color,
            weight: this.weight,
          };
          this.currentPath.push(point);
          // this.socket.emit('mouse', this.paths)
          socketio.sendEvent({
            type: "mouse",
            data: { paths: this.paths, room: this.roomData.roomId },
          });
        }
        this.paths.forEach((path) => {
          p5.beginShape();
          path.forEach((point) => {
            p5.stroke(point.penColor);
            p5.strokeWeight(point.weight);
            p5.vertex(point.x, point.y);
          });
          p5.endShape();
        });
      };
      p5.mousePressed = () => {
        this.currentPath = [];
        this.paths.push(this.currentPath);
        // this.socket.emit('mouse', this.paths)
      };
      // }
    };
    // Attach the canvas to the div
    const p5canvas = new P5(script, "canvas");
    console.log("sketch Loaded", p5canvas);
  },
  methods: {
    changeColor(clr) {
      this.color = clr;
    },
    clearBoard() {
      if (
        this.roomData.roomMaster.playerSocketId === socketio.clientSocketId()
      ) {
        console.log("clearing board");
        socketio.sendEvent({
          type: "ClearBoard",
          data: { roomId: this.roomData.roomId },
        });
      }
    },
  },
};
</script>

<style scoped>
body {
  background: beige;
}
#stroke-input {
  display: block;
  width: 60px;
  height: 40px;
  border-radius: 7px;
  border: none;
  outline: none;
  text-align: center;
  font-family: "poppins";
  font-weight: 600;
  margin-left: 10px;
  margin-top: auto;
  margin-bottom: auto;
}
#clear {
  display: block;
  margin-left: 10px;
  margin-top: auto;
  margin-bottom: auto;
  width: 70px;
  height: 40px;
  background: crimson;
  color: white;
  font-family: "poppins";
  border-radius: 5px;
  border: 1px solid white;
  cursor: pointer;
}
.paletteHolder {
  display: flex;
  margin-top: 20px;
  justify-content: center;
  float: left;
  clear: both;
  margin-left: 10px;
}
#canvas {
  /* cursor: img("logo.png"), auto; */
  cursor: url("https://avatars0.githubusercontent.com/u/1617169?s=16"), auto;
  display: block;
  margin-left: 26%;
  margin-top: 75px;
  border: 9px solid rgb(116, 55, 55);
  width: 619px;
  height: 419px;
  border-radius: 10px;
}
#timer-img {
  display: block;
  margin: auto;
  width: 30px;
  height: 100%;
  border-right: 1px solid rgb(83, 255, 83);
  padding-right: 10px;
}
#timer-text {
  display: block;
  margin: auto;
  color: white;
  font-family: "Glory";
}
.timer-round {
  display: block;
  float: left;
  margin: auto;
  margin-left: 25px;
  font-weight: bold;
  color: white;
  font-family: "Glory";
}
.word {
  display: block;
  margin: auto;
  /* margin-left: 30%; */
  float: left;
  color: white;
  font-family: "Glory";
  font-weight: bold;
  letter-spacing: 3px;
  background-color: rgb(46, 100, 216);
  color: greenyellow;
  border-radius: 10px;
  padding: 5px 10px;
}
.timer {
  display: flex;
  align-items: center;
  width: 160px;
  height: 60px;
  border: 2px solid rgb(83, 255, 83);
  border-radius: 10px;
  margin-left: 34%;
  margin-top: 20px;
}
#full-word {
  font-family: "Glory";
  color: white;
  text-align: center;
  height: 30px;
  margin-top: -35px;
  margin-bottom: 0px;
}
#half-word {
  text-align: center;
  font-family: "Glory";
  color: white;
  margin-right: 5px;
}
#half-word-container {
  margin-left: 5%;
  /* padding-top: 40px; */
  height: 30px;
  margin-top: -30px;
}
.round-indicator {
  text-align: center;
  color: white;
  font-size: 2em;
  display: flex;
  margin-left: 60px;
  align-items: center;
}

.top-row {
  width: 70%; /*  Try setting this to 400px or something */
  display: table;
}
.time-round {
  display: table-cell;
}
.palette-holder-holder {
  display: flex;
}
@media (max-width: 1200px) {
  .top-row {
    width: 65%;
  }
  .paletteHolder {
    width: 70%;
  }
  #canvas {
    margin-left: 30%;
    margin-top: 6vh;
  }
  .timer {
    margin-left: 30%;
  }
}

@media (max-width: 500px) {
  #canvas {
    display: block;
    margin: auto;
  }
  .top-row {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
  }
  .timer-round {
    text-align: center;
    margin: auto;
  }
  .word {
    text-align: center;
    margin: auto;
  }
  .time-round {
    margin: auto;
    display: block;
    margin-top: 10px;
    margin-bottom: 5px;
  }
  .timer {
    margin: auto;
    margin-top: 30px;
  }
  #stroke-input {
    display: block;
    margin: auto;
    position: absolute;
    left: 30vw;
  }
  .paletteHolder {
    display: block;
    float: none;
    width: 100vw;
    margin-left: auto;
    overflow-x: scroll;
  }
  .palette-holder-holder {
    display: flex;
    align-items: center;
    width: 170vw;
  }

  .color {
    width: 40px;
  }

  #clear {
    display: block;
    margin: auto;
    position: absolute;
    left: 55vw;
  }
}
</style>
